import { Box, Grid } from "@chakra-ui/react";
import React from "react";
import useMenuItems from "../../../utils/data/menuitems";
import NavCard from "../../../components/navcard/";

const Home = () => {
  const Menu = useMenuItems();
  return (
    <Box
      display={"flex"}
      h={"100%"}
      w={"100%"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignContent={"center"}
      alignItems={"center"}
      textAlign={"left"}
    >
      <Grid
        templateColumns={[
          "repeat(1, 1fr)",
          "repeat(2, 1fr)",
          "repeat(3, 1fr)",
          "repeat(4, 1fr)",
        ]}
        gap={[4, 4, 5, 5, 5, 10]}
      >
        {Menu.map((item) => (
          <NavCard icon={item.icon} title={item.title} onClick={item.onClick} />
        ))}
      </Grid>
      {/* <DriverDiagram /> */}
    </Box>
  );
};

export default Home;
